<template>
    <div class="d-flex flex-column min-vh-100">
        <BNav class="fixed-top p-3 d-flex align-items-center">
            <BNavbarBrand to="/">
                <img width="180" src="../img/logo.svg">
            </BNavbarBrand>
            <EnvBanner class="ms-auto"></EnvBanner>
        </BNav>
        <router-view class="flex-grow-1 d-flex flex-column"></router-view>
        <Footer></Footer>
    </div>
</template>

<script setup>
import Footer from "./Footer.vue";
import EnvBanner from "./EnvBanner.vue";
import { BNav, BNavbarBrand } from "bootstrap-vue-next";
</script>

<style scoped lang="scss">
@import "../scss/variables";

.nav {
    background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 30rem);
    :after {
        content: '';
        display: block;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        background: linear-gradient(to right, $primary 0%,rgba(211,7,42,0) 30rem);
    }
}
</style>
